'use client'
import React, { HTMLInputTypeAttribute } from 'react';
import { useState } from 'react';

interface IProps {
  title: string;
  required: boolean;
  type: HTMLInputTypeAttribute;
  inputValue: string;
  name: string;
  placeholder: string;
  handleFieldChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  additionalClass?: string;
  errorText?: string;
  errorFields?: string[];
  id?: string;
  hideOptional?: boolean;
}


export const TitleAndInput: React.FC<IProps> = ({ title, required, type, inputValue, name, hideOptional, placeholder, id, handleFieldChange, additionalClass, errorText, errorFields }) => {
  const [hasError, setHasError] = useState<boolean>(false);
  const errorMsgForField = (fieldName: string) => {
    return errorFields?.includes(fieldName) ? 'Please fill in the required field' : undefined;
  }

  const errorMsg = () => {
    let text;
    if (errorText) text = errorText;
    else if (errorMsgForField(name)) {
      text = 'Please fill in required field';
    }
    if (text) {
      if (!hasError) setHasError(true);
      return <div className={'text-red-500 italic text-sm'}>{text}</div>;
    }
    if (hasError) setHasError(false);
    return null;
  }

  return (
    <div id={id} className={`flex flex-col mb-1 ${additionalClass} flex-1 min-w-[240px]`}>
      <div className="text-[16px] font-medium leading-[24px] mb-1">
        {title}
        {required ? <span className={`text-red-700`}> *</span> : hideOptional ? null : <span className={'text-[12px] ml-1'}>(Optional)</span>}
      </div>
      <input
        className={`p-2 rounded-[8px] h-[44px] mb-2 ${hasError ? 'border-2 border-red-500' : 'border-gray-300'}`}
        type={type}
        value={inputValue}
        onChange={handleFieldChange}
        placeholder={placeholder}
        name={name}
      />
      {errorMsg()}
    </div>
  )
}
